/** @jsx jsx */
import { Spacer, Spinner } from "@cd2/components"
import { css, jsx } from "@emotion/core"
import { colors } from "./EOSThemeProvider"

export function PageLoadingScreen() {
  return (
    <div
      css={css`
        min-height: 60vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      `}
    >
      <div>
        <div
          css={css`
            width: 64px;
            border-radius: 4px;
            overflow: hidden;

            img {
              display: block;
              width: 100%;
              overflow: hidden;
              margin: 0 auto;
            }
          `}
        >
          <img src="https://api.fileboy.io/files/get/c173c583-ffcb-4dc0-957f-28ece09fac17+loading_gif " />
        </div>
        <Spacer />
        <div
          css={css`
            width: 64px;
            margin: 0 auto;
            text-align: center;

            > div {
              margin: 0 auto;
            }
          `}
        >
          <Spinner color={colors.primary} size={48} />
        </div>
      </div>
    </div>
  )
}
